import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import { useContextState } from '../context';

const UserProfileNavbar = () => {
  const { t } = useTranslation();
  const { pathname } = useRouter();
  const { authorized } = useContextState();

  const navLinks = [
    { name: `${t('setting')}`, route: '/terminal/settings' },
    { name: `${t('licenses')}`, route: '/terminal/personal-licenses' },
    { name: `${t('order_history_title')}`, route: '/terminal/order-history' },
    { name: `${t('password')}`, route: '/terminal/personal-password' },
  ];

  if (authorized) {
    return (
      <div className="side-menu">
        <div className="side-menu-title">{t('setting')}</div>
        <div className="swiper-wrapper">
          {navLinks.map((item, index) => (
            <div
              key={item.route}
              className={
                navLinks[index]?.route === pathname ? 'swiper-slide active' : 'swiper-slide'
              }
            >
              <Link href={item.route} passHref>
                <a>{item.name}</a>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

export default UserProfileNavbar;
